(function(){
  var THEME_LABELS = {
    'georganiseerde reizen': {label:'Georganiseerde reizen', emoji:'\u{1F9F3}'},
    'premium': {label:'Premium', emoji:'\u2B50'},
    'top 10': {label:'Top 10', emoji:'\u{1F525}'},
    'top 20': {label:'Top 20', emoji:'\u{1F4CC}'},
    'top 5': {label:'Top 5', emoji:'\u{1F947}'},
    'jongerenvakanties': {label:'Jongeren', emoji:'\u{1F389}'},
    'familie': {label:'Familie', emoji:'\u{1F46A}'},
    'cultuur': {label:'Cultuur', emoji:'\u{1F3DB}'},
    'natuur': {label:'Natuur', emoji:'\u{1F33F}'},
    'avontuur': {label:'Avontuur', emoji:'\u{1F9D7}'},
    'eten': {label:'Eten & drinken', emoji:'\u{1F374}'},
    'strand': {label:'Strand', emoji:'\u{1F3D6}'},
    'shoppen': {label:'Shoppen', emoji:'\u{1F6CD}'},
    'nightlife': {label:'Nightlife', emoji:'\u{1F576}'},
    'wellness': {label:'Wellness', emoji:'\u{1F9D8}'}
  };
  var SKIP_TAGS = {'nl':1,'blog':1,'reisgids':1,'stad':1,'city':1,'reizen':1};

  function normalizeThemeTag(tag){
    var t = (tag || '').toLowerCase().trim().replace(/\s+/g, ' ');
    if (!t) return '';
    if (t === 'premium ervaringen') return 'premium';
    if (t === 'eten en drinken') return 'eten';
    if (t === 'georganiseerd' || t === 'georganiseerde reis') return 'georganiseerde reizen';
    if (t === 'joeba top 10' || t === 'top10') return 'top 10';
    if (t === 'joeba top 20' || t === 'top20') return 'top 20';
    if (t === 'joeba top 5' || t === 'top5') return 'top 5';
    if (t === 'jongeren') return 'jongerenvakanties';
    return t;
  }

  function getDerivedThemeTags(article){
    var title = (article.getAttribute('data-article-title') || '').toLowerCase();
    var category = (article.getAttribute('data-article-category') || '').toLowerCase();
    var rawTags = (article.getAttribute('data-article-tags') || '').split(',');
    var themeSet = {};

    rawTags.forEach(function(tag){
      var normalized = normalizeThemeTag(tag);
      if (!normalized) return;
      themeSet[normalized] = 1;
    });

    if (category === 'georganiseerd') themeSet['georganiseerde reizen'] = 1;
    if (title.indexOf('top 20') !== -1 || title.indexOf('20 beste') !== -1) themeSet['top 20'] = 1;
    if (title.indexOf('top 10') !== -1 || title.indexOf('10 beste') !== -1 || title.indexOf('10 activiteiten') !== -1 || title.indexOf('tien activiteiten') !== -1) themeSet['top 10'] = 1;
    if (title.indexOf('top 5') !== -1 || title.indexOf('5 beste') !== -1) themeSet['top 5'] = 1;

    return Object.keys(themeSet);
  }

  function init(explorer){
    if (explorer.dataset.jbExplorerInit) return;
    explorer.dataset.jbExplorerInit = '1';
    var city = (explorer.getAttribute('data-city-explorer') || '').toLowerCase().trim();
    var tabsEl = explorer.querySelector('.joeba-city-explorer__tabs');
    var articlesWrap = explorer.querySelector('[data-jb-articles-rail]');
    if (!tabsEl || !articlesWrap) return;
    var articles = Array.prototype.slice.call(articlesWrap.querySelectorAll('[data-jb-city-card]'));
    if (!articles.length) {
      articlesWrap.parentNode.insertAdjacentHTML('beforeend', '<div class="joeba-city-explorer__empty">Nog geen blogs voor deze stad. Klik op \u201cActiviteiten\u201d voor tips.</div>');
    }
    var tagCounts = {};
    articles.forEach(function(a){
      var tags = getDerivedThemeTags(a);
      var seen = {};
      tags.forEach(function(t){
        t = normalizeThemeTag(t);
        if (seen[t]) return; seen[t] = 1;
        if (t === city) return;
        if (SKIP_TAGS[t]) return;
        tagCounts[t] = (tagCounts[t] || 0) + 1;
      });
      a.dataset.jbTagSet = '|' + tags.join('|') + '|';
    });
    var chips = [];
    Object.keys(THEME_LABELS).forEach(function(t){
      chips.push({tag:t, count:tagCounts[t]||0, info:THEME_LABELS[t]});
    });
    Object.keys(tagCounts).forEach(function(t){
      if (THEME_LABELS[t]) return;
      chips.push({tag:t, count:tagCounts[t], info:{label:t.charAt(0).toUpperCase()+t.slice(1), emoji:'\u{1F516}'}});
    });
    if (!chips.length) return;
    var firstActiveIdx = chips.findIndex(function(c){return c.tag === 'top 10' && c.count > 0;});
    if (firstActiveIdx < 0) firstActiveIdx = chips.findIndex(function(c){return c.count>0;});
    if (firstActiveIdx < 0) firstActiveIdx = 0;
    var html = '';
    chips.forEach(function(c, i){
      var cls = 'joeba-city-explorer__tab' + (i===firstActiveIdx ? ' is-active' : '') + (c.count===0 ? ' is-empty' : '');
      html += '<button type="button" class="' + cls + '" data-jb-tab="' + c.tag + '"><span>' + c.info.emoji + '</span>' + c.info.label + ' <span class="joeba-city-explorer__tab__count">(' + c.count + ')</span></button>';
    });
    tabsEl.innerHTML = html;
    function applyTab(t){
      articles.forEach(function(a){
        var set = a.dataset.jbTagSet || '';
        a.classList.toggle('jb-tab-hidden', set.indexOf('|' + t + '|') === -1);
      });
      var visibleCount = articles.filter(function(a){return !a.classList.contains('jb-tab-hidden');}).length;
      var wrap = articlesWrap.parentNode; // .joeba-city-explorer__articles
      if (wrap) {
        if (visibleCount === 1) wrap.setAttribute('data-jb-fewitems','1');
        else if (visibleCount === 2) wrap.setAttribute('data-jb-fewitems','2');
        else if (visibleCount === 3) wrap.setAttribute('data-jb-fewitems','3');
        else wrap.removeAttribute('data-jb-fewitems');
      }
      if (articlesWrap && articlesWrap.scrollTo) {
        articlesWrap.scrollTo({left: 0, behavior: 'auto'});
      }
      if (typeof updateRailArrows === 'function') setTimeout(updateRailArrows, 50);
    }
    var articlesContainer = explorer.querySelector('.joeba-city-explorer__articles');
    var railArrows = articlesContainer ? articlesContainer.querySelectorAll('.joeba-city-explorer__rail-arrow') : [];
    function railStep(){ return Math.max(240, articlesWrap.clientWidth * 0.85); }
    function updateRailArrows(){
      if (!articlesWrap) return;
      var max = Math.max(0, articlesWrap.scrollWidth - articlesWrap.clientWidth);
      railArrows.forEach(function(a){
        var dir = a.getAttribute('data-jb-rail-dir');
        if (dir === 'prev') a.disabled = articlesWrap.scrollLeft <= 2;
        else a.disabled = articlesWrap.scrollLeft >= max - 2;
      });
    }
    railArrows.forEach(function(a){
      a.addEventListener('click', function(){
        var dir = a.getAttribute('data-jb-rail-dir');
        articlesWrap.scrollBy({left: (dir==='next'?1:-1)*railStep(), behavior:'smooth'});
      });
    });
    if (articlesWrap) {
      articlesWrap.addEventListener('scroll', updateRailArrows, {passive:true});
    }
    window.addEventListener('resize', updateRailArrows);
    applyTab(chips[firstActiveIdx].tag);
    setTimeout(updateRailArrows, 100);
    tabsEl.addEventListener('click', function(e){
      var btn = e.target.closest('[data-jb-tab]');
      if (!btn) return;
      e.preventDefault();
      var t = btn.getAttribute('data-jb-tab');
      tabsEl.querySelectorAll('.joeba-city-explorer__tab').forEach(function(b){b.classList.remove('is-active');});
      btn.classList.add('is-active');
      applyTab(t);
    });
    var wrap = tabsEl.parentNode;
    if (wrap && wrap.classList.contains('joeba-city-explorer__tabs-wrap')) {
      var arrows = wrap.querySelectorAll('.joeba-city-explorer__tabs-arrow');
      function step(){ return Math.max(120, tabsEl.clientWidth * 0.7); }
      function updateArrows(){
        var max = Math.max(0, tabsEl.scrollWidth - tabsEl.clientWidth);
        arrows.forEach(function(a){
          var dir = a.getAttribute('data-jb-tabs-dir');
          if (dir === 'prev') a.disabled = tabsEl.scrollLeft <= 2;
          else a.disabled = tabsEl.scrollLeft >= max - 2;
        });
      }
      arrows.forEach(function(a){
        a.addEventListener('click', function(){
          var dir = a.getAttribute('data-jb-tabs-dir');
          tabsEl.scrollBy({left: (dir==='next'?1:-1)*step(), behavior:'smooth'});
        });
      });
      tabsEl.addEventListener('scroll', updateArrows, {passive:true});
      window.addEventListener('resize', updateArrows);
      updateArrows();
      setTimeout(updateArrows, 200);
    }
  }

  function start(){
    document.querySelectorAll('.joeba-city-explorer[data-city-explorer]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
